export const parametersKeys = {
  getAll: ['all-system-parameters']
};
